<div class="suggestion-card" [class.highlighted]="highlighted" (click)="onCardClick($event)">
  <app-suggestion-meta class="suggestion-card-header" [authorName]="authorName" [createdAtRelative]="createdAtRelative"></app-suggestion-meta>
  @if (variant === 'replaced') {
    <div class="suggestion-card-diff suggestion-card-diff-removed">
      <span class="suggestion-card-diff-label">{{ 'EDITOR.TRACK_CHANGES.SIDEBAR.LABEL_REPLACED' | translate }}</span>
      <span class="suggestion-card-diff-text">
        @for (run of deletionRuns; track $index) {
          <span [class.suggestion-card-diff-run-bold]="run.marks.includes('strong')" [class.suggestion-card-diff-run-italic]="run.marks.includes('italic')">{{
            run.text
          }}</span>
        }
      </span>
    </div>
    <div class="suggestion-card-diff suggestion-card-diff-added">
      <span class="suggestion-card-diff-label">{{ 'EDITOR.TRACK_CHANGES.SIDEBAR.LABEL_WITH' | translate }}</span>
      <span class="suggestion-card-diff-text">
        @for (run of insertionRuns; track $index) {
          <span [class.suggestion-card-diff-run-bold]="run.marks.includes('strong')" [class.suggestion-card-diff-run-italic]="run.marks.includes('italic')">{{
            run.text
          }}</span>
        }
      </span>
    </div>
  } @else if (variant === 'removed') {
    <div class="suggestion-card-diff suggestion-card-diff-removed">
      <span class="suggestion-card-diff-label">{{ 'EDITOR.TRACK_CHANGES.SIDEBAR.LABEL_REMOVED' | translate }}</span>
      <span class="suggestion-card-diff-text">
        @for (run of deletionRuns; track $index) {
          <span [class.suggestion-card-diff-run-bold]="run.marks.includes('strong')" [class.suggestion-card-diff-run-italic]="run.marks.includes('italic')">{{
            run.text
          }}</span>
        }
      </span>
    </div>
  } @else if (variant === 'formatting') {
    @if (formattingText.length > 0) {
      <div class="suggestion-card-diff suggestion-card-diff-formatting">
        <span class="suggestion-card-diff-label">{{ 'EDITOR.TRACK_CHANGES.SIDEBAR.LABEL_FORMATTED' | translate }}</span>
        <span class="suggestion-card-diff-text">{{ formattingText }}</span>
      </div>
    }
  } @else {
    <div class="suggestion-card-diff suggestion-card-diff-added">
      <span class="suggestion-card-diff-label">{{ 'EDITOR.TRACK_CHANGES.SIDEBAR.LABEL_ADDED' | translate }}</span>
      <span class="suggestion-card-diff-text">
        @for (run of insertionRuns; track $index) {
          <span [class.suggestion-card-diff-run-bold]="run.marks.includes('strong')" [class.suggestion-card-diff-run-italic]="run.marks.includes('italic')">{{
            run.text
          }}</span>
        }
      </span>
    </div>
  }
  @if (structureText.length > 0) {
    <div class="suggestion-card-diff suggestion-card-diff-formatting">
      <span class="suggestion-card-diff-label">{{ 'EDITOR.TRACK_CHANGES.STRUCTURE' | translate }}</span>
      <span class="suggestion-card-diff-text">{{ structureText }}</span>
    </div>
  }
  <div class="suggestion-card-actions">
    @if (canResolve) {
      <button type="button" class="suggestion-card-button suggestion-card-button-accept" (click)="onAccept()">
        <mat-icon>check</mat-icon>
        <span>{{ 'EDITOR.TRACK_CHANGES.ACCEPT' | translate }}</span>
      </button>
      <button type="button" class="suggestion-card-button suggestion-card-button-reject" (click)="onReject()">
        <mat-icon>close</mat-icon>
        <span>{{ 'EDITOR.TRACK_CHANGES.REJECT' | translate }}</span>
      </button>
    }
    <button type="button" class="suggestion-card-button suggestion-card-button-view" (click)="onView()">
      <mat-icon>visibility</mat-icon>
      <span>{{ 'EDITOR.TRACK_CHANGES.SIDEBAR.ACTION_VIEW' | translate }}</span>
    </button>
  </div>
  <div class="suggestion-card-actions-divider"></div>
  <app-thread-comments
    [thread]="thread"
    [currentUser]="currentUser"
    [canPostComment]="canPostComment"
    (submitComment)="onSubmitComment($event)"
  ></app-thread-comments>
</div>
